export const isMobileUserAgent = (userAgent) =>
  /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
